import { useState, useEffect, useContext } from "react";
import { PricingPortalAPI } from "../apis/pricing-api";
import { DisplaySpinnerContext } from "../context/ContextIndex";
import { useBranchCostConfigList } from "../hooks/useBranchCostConfigList";

const useGrossBranchFormData = (businessCode, countryCode) => {
  const branchCostConfigList = useBranchCostConfigList(businessCode, countryCode);
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const [grossBranchFormLookupData, setGrossBranchLookupData] = useState();

  useEffect(() => {
    const fetchLookupData = async () => {
      try {
        let _marketSectorList = await PricingPortalAPI.getFilterList(businessCode, countryCode, "getMarketSectorList", "marketsector", `&status=active`);
        let _formattedMarketSectorList = _marketSectorList.map((item) => {
          return {
            SectorId: item.SectorId,
            SectorName: item.SectorName,
          };
        });
        let _serviceTypeList = await PricingPortalAPI.getFilterList(businessCode, countryCode, "getServiceTypeList", "servicetype", `&status=active`);
        let _formattedServiceTypeList = _serviceTypeList.map((item) => {
          return {
            ServiceTypeId: item.ServiceTypeId,
            ServiceName: item.ServiceName,
          };
        });
        let _formattedBranchList = null;
        if (branchCostConfigList) {
          _formattedBranchList = branchCostConfigList.map((item) => {
            return {
              BranchId: item.BranchId,
              BranchName: "" + item.BranchNumber + " - " + item.BranchName,
            };
          });
        }
        if (_formattedMarketSectorList && _formattedServiceTypeList && _formattedBranchList) {
          setGrossBranchLookupData({
            marketSectorList: _formattedMarketSectorList,
            serviceTypeList: _formattedServiceTypeList,
            branchList: _formattedBranchList,
          });
        }
      } catch (err) {
        spinnerCtx.setLoadingIndicator(false);
        alert(err);
      }
    };
    // spinnerCtx.setLoadingIndicator(true);
    fetchLookupData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchCostConfigList]);
  return grossBranchFormLookupData;
};

export { useGrossBranchFormData };
